import React, {useEffect, useReducer, useState} from 'react'
import ProductGeneralTab from './add-product/ProductGeneralTab'
import {fieldReducer, productInitialState} from './cors/reducers'
import SharedData from '../common/SharedData'
import Loader from '../common/Loader'
import {useParams} from 'react-router-dom'
import { useIntl } from 'react-intl'
import '../../stylesheet/RejctionTag.css'
import '../../modules/reports/payment-video.css'
import './add-product/add-single-product.css'
import {TutorialVideoLink} from '../../tenant/TutorialVideoLink'

const AddProduct = () => {
  const {formatMessage} = useIntl()
  const {currentUser, language} = SharedData()
  let {productID} = useParams()
  const [state, dispatch] = useReducer(fieldReducer, productInitialState)
  const [showVideoHighlight, setShowVideoHighlight] = useState(false);

  useEffect(() => {
    const hasSeenVideo = document.cookie
      .split(';')
      .some(item => item.trim().startsWith('add_product_video='));

    setShowVideoHighlight(!hasSeenVideo);
  }, []);

  // Paint the content canvas in the design's page colour (#F7F8FA) while this
  // page is mounted; restore it on unmount so other pages are unaffected.
  useEffect(() => {
    const el = document.getElementById('kt_app_content')
    el?.classList.add('aps-page-bg')
    return () => el?.classList.remove('aps-page-bg')
  }, []);
  return (
    <div className='aps-root position-relative add-product-page'>
      <div className='aps-header'>
        <h2 className='aps-title'>
          {productID
            ? formatMessage({id: 'edit_single_prod'})
            : formatMessage({id: 'add_single_prod'})}
        </h2>
        <TutorialVideoLink
          section="add_product"
          fallback="https://www.youtube.com/watch?v=sQfoROahaIU"
          target="_blank"
          rel="noopener noreferrer"
          className={`aps-tutorial-btn ${showVideoHighlight ? 'video-highlight' : ''}`}
          onClick={() => {
            document.cookie = "add_product_video=seen";
            setShowVideoHighlight(false);
          }}
        >
          <i className='fas fa-circle-play' aria-hidden='true'></i>
          <span>{formatMessage({ id: 'watch_tutorial' })}</span>
        </TutorialVideoLink>
      </div>

      {/* Multi-supplier (T3): editing an existing catalog product (not a
          pending request/draft, which carry '&' in the id). Clarify the
          catalog-vs-offer split — price/qty edits hit the supplier's own
          offer; shared catalog content goes through review. */}
      {productID && !productID.includes('&') ? (
        <div className='alert alert-light-primary d-flex align-items-center' role='note'>
          <i className='fas fa-info-circle me-2' aria-hidden='true' />
          <span>{formatMessage({id: 'product_edit_offer_note'})}</span>
        </div>
      ) : null}

      <ProductGeneralTab prodState={state} prodDispatch={dispatch} />

      {state.isLoading && <Loader isFull={true} />}
    </div>
  )
}

export default AddProduct
